/* Wuda privacy bridge. Shopify is the source of truth; never replay localStorage consent. */
(function () {
  'use strict';
  if (window.WudaPrivacy) return;
  let pending;
  const purposes = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
  function ready() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return Promise.resolve(window.Shopify.customerPrivacy);
    }
    if (pending) return pending;
    pending = new Promise(function (resolve, reject) {
      let attempts = 0;
      function load() {
        const shopify = window.Shopify;
        if (shopify && shopify.customerPrivacy) { resolve(shopify.customerPrivacy); return; }
        if (shopify && typeof shopify.loadFeatures === 'function') {
          const timeout = setTimeout(function () { reject(new Error('Privacy API load timed out')); }, 10000);
          try {
            shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
              clearTimeout(timeout);
              if (error || !shopify.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
              else resolve(shopify.customerPrivacy);
            });
          } catch (error) { clearTimeout(timeout); reject(error); }
          return;
        }
        attempts += 1;
        if (attempts < 40) setTimeout(load, 100);
        else reject(new Error('Shopify feature loader unavailable'));
      }
      load();
    }).catch(function (error) { pending = null; throw error; });
    return pending;
  }
  function snapshot(api) {
    return typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : {};
  }
  function setConsent(consent) {
    // Call ONLY in response to an explicit accept/decline/preferences action.
    const update = {};
    if (!consent || typeof consent !== 'object') return Promise.reject(new TypeError('Consent must be an object'));
    for (const key of purposes) {
      if (!Object.prototype.hasOwnProperty.call(consent, key)) continue;
      if (typeof consent[key] !== 'boolean') return Promise.reject(new TypeError('Consent values must be boolean'));
      update[key] = consent[key];
    }
    if (!Object.keys(update).length) return Promise.reject(new TypeError('No consent purposes supplied'));
    return ready().then(function (api) {
      return new Promise(function (resolve, reject) {
        const timeout = setTimeout(function () { reject(new Error('Consent could not be saved')); }, 10000);
        try {
          api.setTrackingConsent(update, function (response) {
            clearTimeout(timeout);
            if (response && response.error) { reject(new Error(String(response.error))); return; }
            resolve(snapshot(api));
          });
        } catch (error) { clearTimeout(timeout); reject(error); }
      });
    });
  }
  window.WudaPrivacy = { ready: ready, setConsent: setConsent };
  // Retain the old integration name without changing unspecified purposes or sale/sharing choices.
  window.setShopifyConsent = setConsent;
  document.addEventListener('visitorConsentCollected', function () {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      document.dispatchEvent(new CustomEvent('shopify:privacy:consent-updated', {
        detail: snapshot(window.Shopify.customerPrivacy)
      }));
    }
  });
  ready().catch(function () {
    // The storefront stays usable when the API is blocked; do not infer or grant consent.
  });
})();
